export const GET_TERMINALS_BY_STORE = `
  query getTerminalsByStore($storeCorrelationId: UUID!) {
    getTerminalsByStore(storeCorrelationId: $storeCorrelationId) {
      correlationId
      storeCorrelationId
      name
      terminalType
      provider
      providerTerminalId
      serialNumber
      registrationStatus
      active
      lastSeenAt
      createdAt
      updatedAt
    }
  }
`;

export const GET_STATIONS_BY_STORE = `
  query getStationsByStore($storeCorrelationId: UUID!) {
    getStationsByStore(storeCorrelationId: $storeCorrelationId) {
      correlationId
      storeCorrelationId
      name
      defaultTerminalId
      defaultTerminalCorrelationId
      defaultReceiptPrinterCorrelationId
      customerDisplayEnabled
      active
      createdAt
      updatedAt
    }
  }
`;

export const GET_STORE_TIP_AUTH_CONFIG = `
  query getStoreTipAuthConfig($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      tipAuthBufferPercentage
      tipAuthMinDollarCents
      tipAuthMaxDollarCents
    }
  }
`;

export const GET_QUICK_SERVICE_SETUP = `
  query quickServiceSetup($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter) {
    categoriesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter) {
      correlationId
      name
      items {
        correlationId
        englishName
        priceCents
        isQuickServiceChoiceItem
        active
      }
    }
    quickServiceChoiceGroups(storeCorrelationId: $storeCorrelationId) {
      correlationId
      storeCorrelationId
      name
      description
      renderSequence
      items {
        correlationId
        itemCorrelationId
        displayNameSnapshot
        priceDeltaCents
        renderSequence
        item {
          correlationId
          englishName
          priceCents
        }
      }
    }
    quickServiceCombos(storeCorrelationId: $storeCorrelationId) {
      correlationId
      storeCorrelationId
      name
      priceCents
      taxRate
      renderSequence
      comboGroups {
        correlationId
        quickServiceComboCorrelationId
        comboItemCorrelationId
        choiceGroupCorrelationId
        displayName
        minSelections
        maxSelections
        isRequired
        renderSequence
        choiceGroup {
          correlationId
          name
        }
      }
    }
  }
`;

/** One query for all tip-related settings (Tip Authorization, Dine-in auto-tip, Suggested Tips). */
export const GET_STORE_TIP_SETTINGS = `
  query getStoreTipSettings($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      tipAuthBufferPercentage
      tipAuthMinDollarCents
      tipAuthMaxDollarCents
      dineInAutoTipPartySizeThreshold
      dineInAutoTipPercentage
      suggestedTipPercentages {
        tipPercentage
      }
    }
  }
`;

export const GET_CARD_PROCESSING_FEE_SETTINGS = `
  query stores($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      passCardProcessingFeeToCustomer
      cardProcessingFeeEnabledByPlatform
      cardProcessingFeePercentBps
    }
  }
`;

export const PLANS = `query plans {
    plans{
      name,
      productDescription,
      monthlyPriceMonthlyBilled,
      monthlyPriceAnnuallyBilled,
      features
    }
  }`;

export const GET_ALL_RESTAURANTS = `query loggedInUserStores {
   loggedInUserStores {
     correlationId
     name
     bucketKeyName
     employeeCount
     planId
     storeAllowedFeatures
     userAllowedFeatures
     storeStaffRole
     address {
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
      deliveryPolicies {
        startMile
        endMile
        deliveryChargeCents
      }
      latitude
      longitude
    }
  }`;

export const RESTAURANT_SUBSCRIPTION_TAB_DATA = `
  query restaurantSubscriptionTabData($restaurantSubscriptionTabDataInput: RestaurantSubscriptionTabDataInput!) {
    restaurantSubscriptionTabData(restaurantSubscriptionTabDataInput: $restaurantSubscriptionTabDataInput) {
      customerPortalUrl
      eatsbitsSubscription {
        stripeSubscriptionId
        planId
        currentPeriodStart
        currentPeriodEnd
        status
        cancelAtPeriodEnd
        cancelAt
        canceledAt
      }
      invoices {
        stripeInvoiceNumber
        invoiceCreatedAtByStripe
        status
        periodStart
        periodEnd
        hostedInvoiceUrl
        nextPaymentAttempt
        totalExcludingTaxCents
        description
      }
      subscribedPlan {
        planId
        tier
        frequency
        priceCents
        productName
        productDescription
      }
      upcomingInvoice {
        stripeInvoiceNumber
        invoiceCreatedAtByStripe
        description
        status
        totalExcludingTaxCents
        periodStart
        periodEnd
        nextPaymentAttempt
        hostedInvoiceUrl
      }
    }
  }
`;

export const GET_STORE_RECEIPT_SETTINGS = `
  query stores($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      receiptFontSizeRestaurantCopy
      receiptFontSizeCustomerCopy
      receiptFontSizeKitchenCopy
      secondLanguage
      defaultLocale
      enabledLocales
      receiptLanguageRestaurantCopy
      receiptLanguageCustomerCopy
      receiptLanguageKitchenCopy
      printReceiptAfterPayment
      popularItemSortingEnabled
      popularItemSortingDays
    }
  }
`;

export const GET_PLATFORM_SUPPORTED_LOCALES = `
  query platformSupportedLocales {
    platformSupportedLocales {
      code
      label
      nativeLabel
    }
  }
`;

export const GET_STORE_FEATURES = `
  query stores($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      planId
      storeAllowedFeatures
      userAllowedFeatures
    }
  }
`;

export const STORES = `
  query stores($retrieveStoresInput: RetrieveStoresInput!) {
    stores(retrieveStoresInput: $retrieveStoresInput) {
      correlationId
      name
      nonEnglishName
      operationMode
      receiptFontSizeRestaurantCopy
      receiptFontSizeCustomerCopy
      receiptFontSizeKitchenCopy
      primaryContactPhoneNumber
      primaryContactEmail
      primaryContactFirstName
      primaryContactLastName
      style
      employeeCount
      connectedAccountId
      bucketKeyName
      categories {
        correlationId
        name
      }
      modifierCategories {
        correlationId
        name
        nonEnglishName
      }
      operationHours {
        day
        startTimeInSeconds
        endTimeInSeconds
      }
      address {
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
      planId
      storeAllowedFeatures
      userAllowedFeatures
      latitude
      longitude
      deliveryPolicies {
        startMile
        endMile
        deliveryChargeCents
      }
      suggestedTipPercentages {
        tipPercentage
      }
      storeEvents {
        correlationId
        storeCorrelationId
        eventName
        eventDescription
        startDate
        endDate
        startTimeInSeconds
        endTimeInSeconds
        active
        eventItems {
          correlationId
          itemCorrelationId
          discountType
          discountPercent
          discountFixedPriceCents
          finalPriceCents
        }
        recurrences {
          correlationId
          recurrenceRule
        }
      }
    }
  }
`;

export const GET_MENU_CATEGORIES = `query categoriesByStoreCorrelationId($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter){
  categoriesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter){
    correlationId
    name
    nonEnglishName
    bucketKeyName
    active
    translations {
      locale
      name
      description
    }
    items{
      correlationId
      abbreviation
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      priceCents
      taxRate
      active
      itemTags{
        correlationId
        storeCorrelationId
        itemCorrelationId
        tagCorrelationId
        tagName
      }
      bucketKeyName
      printer{
        correlationId
        assignedName
        model
      }
      itemOptions{
        correlationId
        name
        nonEnglishName
        description
        renderSequence
        isRequired
        translations {
          locale
          name
          description
        }
        itemOptionElements{
          correlationId
          name
          nonEnglishName
          description
          renderSequence
          priceCents
          translations {
            locale
            name
            description
          }
        }
      }
    }
  }
}`;

export const GET_ITEMS = `query itemsByCategoryCorrelationId ($categoryCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter){
  itemsByCategoryCorrelationId(categoryCorrelationId: $categoryCorrelationId, activeFilter: $activeFilter){
    correlationId
    englishName
    nonEnglishName
    englishDescription
    nonEnglishDescription
    priceCents
    isQuickServiceChoiceItem
    enterpriseEnabled
    active
    bucketKeyName
    abbreviation,
    taxRate,
    translations {
      locale
      name
      description
    }
    itemOptions {
      correlationId
      name
      nonEnglishName
      description
      renderSequence
      isRequired
      multipleSelectionsAllowed
      translations {
        locale
        name
        description
      }
      itemOptionElements {
        correlationId
        name
        nonEnglishName
        description
        renderSequence
        priceCents
        translations {
          locale
          name
          description
        }
      }
    }
      itemTags {
        tagCorrelationId
      }
        printer {
          assignedName
          correlationId
          ipAddress
          model
          port
          protocol
      }
  }
}`;

// Layout is nested under StoreTable.layout (same as eatsbitsdesktop). Use layout.x, layout.y, etc. for the 2D view.
export const GET_TABLES = `query StoreTablesByStoreCorrelationId($storeCorrelationId: UUID!) {
  storeTablesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId) {
    correlationId
    storeCorrelationId
    tableNumber
    tableSize
    section
    status
    currentOrderCorrelationId
    publicToken
    layout {
      tableId
      tableCorrelationId
      storeCorrelationId
      sectionId
      x
      y
      width
      height
      rotation
      shape
    }
  }
}`;

export const GET_COMBOS = `query combosByStoreCorrelationId ($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter){
  combosByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter){
   correlationId
    englishName
    nonEnglishName
    englishDescription
    nonEnglishDescription
    priceCents
    taxRate
    bucketKeyName
    active
    translations {
      locale
      name
      description
    }
    itemList{
      correlationId
      abbreviation
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      priceCents
      taxRate
      bucketKeyName
      active
      itemOptions {
      	correlationId
        name
        nonEnglishName
        description
        renderSequence
        isRequired
        translations {
          locale
          name
          description
        }
        itemOptionElements{
          correlationId
          name
          nonEnglishName
          description
          renderSequence
          priceCents
          translations {
            locale
            name
            description
          }
        }
      }
    }
  }
}`;

export const GET_PROMOTIONS = `query promotionsByStore($storeCorrelationId: UUID!) {
  promotionsByStore(storeCorrelationId: $storeCorrelationId) {
    correlationId
    storeCorrelationId
    name
    description
    status
    promotionType
    discountValue
    currency
    startsAt
    expiresAt
    minSubtotalCents
    maxDiscountCents
    maxRedemptionsTotal
    maxRedemptionsPerCustomer
    appliesToOrderType
    firstTimeCustomerOnly
    archivedAt
  }
}`;

export const GET_PROMOTION_BY_CORRELATION_ID = `query promotionByCorrelationId($storeCorrelationId: UUID!, $promotionCorrelationId: UUID!) {
  promotionByCorrelationId(storeCorrelationId: $storeCorrelationId, promotionCorrelationId: $promotionCorrelationId) {
    correlationId
    storeCorrelationId
    name
    description
    status
    promotionType
    discountValue
    currency
    startsAt
    expiresAt
    minSubtotalCents
    maxDiscountCents
    maxRedemptionsTotal
    maxRedemptionsPerCustomer
    appliesToOrderType
    firstTimeCustomerOnly
    archivedAt
  }
}`;

export const GET_STORE_CUSTOMERS = `
  query storeCustomers($storeCorrelationId: UUID!, $first: Int, $after: String, $last: Int, $before: String, $search: StoreCustomerSearchInput) {
    storeCustomers(storeCorrelationId: $storeCorrelationId, first: $first, after: $after, last: $last, before: $before, search: $search) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfCustomers
      }
      edges {
        cursor
        node {
          correlationId
          name
          email
          phone
          visitTimes
          lastVisitTime
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
      }
    }
  }
`;

export const GET_CUSTOMER_ORDERS = `
  query customerOrdersByStoreCorrelationId($storeCorrelationId: UUID!, $first: Int, $after: String, $last: Int, $before: String) {
    customerOrdersByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfOrders
        earliestOrderYear
      }
      edges {
        cursor
        node {
          correlationId
          createdAt
          customerCorrelationId
          parentOrderCorrelationId
          customerFirstName
          customerLastName
          customerEmail
          customerPhoneNumber
          storeCorrelationId
          storeName
          isGuest
          orderStatus
          orderType
          orderSource
          tableNumber
          totalItemQuantity
          sentToPrinterClient
          customerNote
          paid
          serverFirstName
          serverLastName
          serverEmployeeCorrelationId
          deliveryAddressLine1
          deliveryAddressLine2
          deliveryCity
          deliveryState
          deliveryZipcode
          tipCents
          deliveryChargeCents
          subtotalCents
          totalTaxCents
          orderLevelDiscountCents
          orderTotalDiscountCents
          promotionCorrelationId
          promotionCodeCorrelationId
          appliedPromotionCode
          promotionSnapshotJson
          totalFeeCents
          cardProcessingFeeCents
          cardProcessingFeePercentBps
          totalCents
          signatureBucketKeyName
          signatureCapturedAt
          signatureCapturedByStationCorrelationId
          scheduledAt
          holdUntil
          channelCorrelationId
          channelName
          closedAt
          voidedAt
          voidedBy
          voidReasonCode
          voidReasonNote
          payment {
            correlationId
            storeCorrelationId
            customerOrderCorrelationId
            paymentDate
            paymentAmountCents
            paymentMethodType
            paymentMethodBrand
            last4Digits
            paymentStatus
            paymentType
            changeCents
            createdAt
          }
          items {
            correlationId
            quantity
            isCombo
            englishName
            nonEnglishName
            englishDescription
            nonEnglishDescription
            taxRate
            bucketKeyName
            itemCorrelationId
            itemOptionElements
            holdUntil
            customerNote
            basePriceCents
            optionsTotalCents
            unitPriceCents
            lineSubtotalCents
            lineTotalCents
            totalCents
            orderItemChoices {
              correlationId
              choiceType
              choiceName
              choiceNonEnglishName
              choiceCorrelationId
              orderItemChoiceDetails {
                correlationId
                choiceDetailType
                choiceDetailName
                choiceDetailNonEnglishName
                choiceDetailCorrelationId
                choiceDetailPriceCents
                quantity
              }
            }
            discounts {
              correlationId
              orderItemCorrelationId
              discountCents
              discountPercentage
              discountReason
              discountApplyType
              discountType
              discountReference
            }
          }
          discounts {
            correlationId
            discountCents
            discountPercentage
            discountReason
            discountApplyType
            discountType
            discountReference
          }
        }
      }
    }
  }
`;

/** Completed orders (history): exclude OPEN so only CLOSED/VOIDED. Optional orderType filters the connection (pagination applies to the filtered set). */
export const GET_COMPLETED_ORDERS = `
  query customerOrdersByStoreCorrelationIdCompleted(
    $storeCorrelationId: UUID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $startTimeInEpochMilli: Long
    $endTimeInEpochMilli: Long
    $excludeOrderStatus: OrderStatusEnum
    $orderType: OrderTypeEnum
  ) {
    customerOrdersByStoreCorrelationId(
      storeCorrelationId: $storeCorrelationId
      first: $first
      after: $after
      last: $last
      before: $before
      startTimeInEpochMilli: $startTimeInEpochMilli
      endTimeInEpochMilli: $endTimeInEpochMilli
      excludeOrderStatus: $excludeOrderStatus
      orderType: $orderType
    ) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfOrders
        earliestOrderYear
      }
      edges {
        cursor
        node {
          correlationId
          parentOrderCorrelationId
          createdAt
          currentDayOrderCount
          hasSplitOrders
          customerCorrelationId
          customerFirstName
          customerLastName
          customerEmail
          customerPhoneNumber
          storeCorrelationId
          storeName
          isGuest
          orderStatus
          orderType
          orderSource
          tableNumber
          totalItemQuantity
          sentToPrinterClient
          customerNote
          paid
          serverFirstName
          serverLastName
          serverEmployeeCorrelationId
          deliveryAddressLine1
          deliveryAddressLine2
          deliveryCity
          deliveryState
          deliveryZipcode
          tipCents
          deliveryChargeCents
          subtotalCents
          totalTaxCents
          orderLevelDiscountCents
          orderTotalDiscountCents
          promotionCorrelationId
          promotionCodeCorrelationId
          appliedPromotionCode
          promotionSnapshotJson
          totalFeeCents
          cardProcessingFeeCents
          cardProcessingFeePercentBps
          totalCents
          signatureBucketKeyName
          signatureCapturedAt
          signatureCapturedByStationCorrelationId
          scheduledAt
          holdUntil
          channelCorrelationId
          channelName
          channelOrderNumber
          closedAt
          voidedAt
          voidedBy
          voidReasonCode
          voidReasonNote
          payment {
            correlationId
            storeCorrelationId
            customerOrderCorrelationId
            paymentDate
            paymentAmountCents
            paymentMethodType
            paymentMethodBrand
            last4Digits
            paymentStatus
            paymentType
            changeCents
            createdAt
          }
          items {
            correlationId
            quantity
            isCombo
            englishName
            nonEnglishName
            englishDescription
            nonEnglishDescription
            taxRate
            bucketKeyName
            itemCorrelationId
            itemOptionElements
            holdUntil
            customerNote
            basePriceCents
            optionsTotalCents
            unitPriceCents
            lineSubtotalCents
            lineTotalCents
            totalCents
            orderItemChoices {
              correlationId
              choiceType
              choiceName
              choiceNonEnglishName
              choiceCorrelationId
              orderItemChoiceDetails {
                correlationId
                choiceDetailType
                choiceDetailName
                choiceDetailNonEnglishName
                choiceDetailCorrelationId
                choiceDetailPriceCents
                quantity
              }
            }
            discounts {
              correlationId
              orderItemCorrelationId
              discountCents
              discountPercentage
              discountReason
              discountApplyType
              discountType
              discountReference
            }
          }
          discounts {
            correlationId
            discountCents
            discountPercentage
            discountReason
            discountApplyType
            discountType
            discountReference
          }
        }
      }
    }
  }
`;

export const GET_EMPLOYEE = `query storeEmployeesByStoreCorrelationId($storeCorrelationId: UUID!){
  storeEmployeesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId){
    correlationId
    storeStaffId
    storeStaffRole
    firstName
    lastName
    email
    phoneNumber
    employerName
    roles
  }
}
`;
export const GET_CUSTOMER_ORDER_FOR_EMPLOYEE = `
  query activeCustomerOrdersByStoreCorrelationId($storeCorrelationId: UUID!) {
    activeCustomerOrdersByStoreCorrelationId(storeCorrelationId: $storeCorrelationId) {
      correlationId
      createdAt
      customerCorrelationId
      parentOrderCorrelationId
      customerFirstName
      customerLastName
      customerEmail
      customerPhoneNumber
      storeCorrelationId
      storeName
      isGuest
      orderStatus
      orderType
      orderSource
      tableNumber
      totalItemQuantity
      sentToPrinterClient
      customerNote
      paid
      serverFirstName
      serverLastName
      serverEmployeeCorrelationId
      deliveryAddressLine1
      deliveryAddressLine2
      deliveryCity
      deliveryState
      deliveryZipcode
      tipCents
      deliveryChargeCents
      subtotalCents
      totalTaxCents
      orderLevelDiscountCents
      orderTotalDiscountCents
      promotionCorrelationId
      promotionCodeCorrelationId
      appliedPromotionCode
      promotionSnapshotJson
      discounts {
        correlationId
        discountCents
        discountPercentage
        discountReason
        discountApplyType
        discountType
        discountReference
      }
      totalFeeCents
      cardProcessingFeeCents
      cardProcessingFeePercentBps
      totalCents
      scheduledAt
      holdUntil
      enterpriseCompanyCorrelationId
      enterpriseSiteCorrelationId
      enterpriseDailyMenuCorrelationId
      enterpriseDeliveryBatchCorrelationId
      enterpriseCompanyName
      enterpriseSiteName
      enterpriseDeliveryAddressLine1
      enterpriseDeliveryAddressLine2
      enterpriseDeliveryCity
      enterpriseDeliveryState
      enterpriseDeliveryZipcode
      enterprisePickupLocation
      enterpriseDeliveryAt
      enterpriseCutoffAt
      enterpriseDispatchSlipPrintedAt
      enterpriseDispatchSlipPrintCount
      enterpriseDispatchSlipLastPrintedAt
      enterpriseDispatchSlipPrintedBy
      channelCorrelationId
      channelName
      channelOrderNumber
      currentDayOrderCount
      hasSplitOrders
      partySize
      payment {
        correlationId
        storeCorrelationId
        customerOrderCorrelationId
        paymentDate
        paymentAmountCents
        paymentMethodType
        paymentMethodBrand
        last4Digits
        paymentStatus
        paymentType
        paymentMode
        changeCents
        createdAt
        nmiTransactionId
        amountAuthorizedCents
        amountCapturedCents
      }
      items {
        correlationId
        quantity
        isCombo
        englishName
        nonEnglishName
        englishDescription
        nonEnglishDescription
        taxRate
        bucketKeyName
        itemCorrelationId
        itemOptionElements
        holdUntil
        customerNote
        basePriceCents
        optionsTotalCents
        unitPriceCents
        lineSubtotalCents
        lineTotalCents
        totalCents
        orderItemChoices {
          correlationId
          choiceType
          choiceName
          choiceNonEnglishName
          choiceCorrelationId
          orderItemChoiceDetails {
            correlationId
            choiceDetailType
            choiceDetailName
            choiceDetailNonEnglishName
            choiceDetailCorrelationId
            choiceDetailPriceCents
            quantity
          }
        }
        discounts {
          correlationId
          orderItemCorrelationId
          discountCents
          discountPercentage
          discountReason
          discountApplyType
          discountType
          discountReference
        }
      }
    }
  }
`;

export const GET_CUSTOMER_TABLE_ORDER_FOR_UPDATE = `query customerOrderByCorrelationId($customerOrderCorrelationId: UUID!){
  customerOrderByCorrelationId(customerOrderCorrelationId: $customerOrderCorrelationId) {
    correlationId
    createdAt
    customerCorrelationId
    parentOrderCorrelationId
    customerFirstName
    customerLastName
    customerEmail
    customerPhoneNumber
    storeCorrelationId
    storeName
    isGuest
    orderStatus
    orderType
    orderSource
    tableNumber
    totalItemQuantity
    sentToPrinterClient
    customerNote
    paid
    serverFirstName
    serverLastName
    serverEmployeeCorrelationId
    deliveryAddressLine1
    deliveryAddressLine2
    deliveryCity
    deliveryState
    deliveryZipcode
    tipCents
    deliveryChargeCents
    subtotalCents
    totalTaxCents
    orderLevelDiscountCents
    orderTotalDiscountCents
    totalFeeCents
    cardProcessingFeeCents
    cardProcessingFeePercentBps
    totalCents
    scheduledAt
    holdUntil
    channelCorrelationId
    channelName
    payment {
      correlationId
      storeCorrelationId
      customerOrderCorrelationId
      paymentDate
      paymentAmountCents
      paymentMethodType
      paymentMethodBrand
      last4Digits
      paymentStatus
      paymentType
      changeCents
      createdAt
    }
    items {
      correlationId
      quantity
      isCombo
      englishName
      nonEnglishName
      englishDescription
      nonEnglishDescription
      taxRate
      bucketKeyName
      itemCorrelationId
      itemOptionElements
      holdUntil
      customerNote
      basePriceCents
      optionsTotalCents
      unitPriceCents
      lineSubtotalCents
      lineTotalCents
      totalCents
      orderItemChoices {
        correlationId
        choiceType
        choiceName
        choiceNonEnglishName
        choiceCorrelationId
        orderItemChoiceDetails {
          correlationId
          choiceDetailType
          choiceDetailName
          choiceDetailNonEnglishName
          choiceDetailCorrelationId
          choiceDetailPriceCents
          quantity
        }
      }
      discounts {
        correlationId
        orderItemCorrelationId
        discountCents
        discountPercentage
        discountReason
        discountApplyType
        discountType
        discountReference
      }
    }
    discounts {
      correlationId
      discountCents
      discountPercentage
      discountReason
      discountApplyType
      discountType
      discountReference
    }
  }
}
`;

export const GET_SALES_HISTORY = `query salesHistoryByStoreCorrelationId($getSalesHistoryInput: GetSalesHistoryInput!){
   salesHistoryByStoreCorrelationId(getSalesHistoryInput: $getSalesHistoryInput){
		bucket
    storeCorrelationId
    orderNumber
    storeTotalPriceCents
    averageOrderTotalPriceCents
    }
  }
`;

export const GET_EXISTING_CUSTOMER = `query customersByPhoneNumber($customersByPhoneNumberOrEmailInput: CustomersByPhoneNumberOrEmailInput!) {
  customersByPhoneNumber(customersByPhoneNumberOrEmailInput: $customersByPhoneNumberOrEmailInput) {
    correlationId
    firstName
    lastName
    email
    phoneNumber
    address{
        addressLine1
				addressLine2
        city
        state
        zipCode
      }
  }
}
`;

export const GET_DELIVERY_CHARGES = `query deliveryCharge($deliveryChargeInput: DeliveryChargeInput!){
    deliveryCharge(deliveryChargeInput: $deliveryChargeInput)
}
`;

export const GET_CUSTOMERS_BY_CORRELATIONIDS = `query customersByCorrelationIds($customersByCorrelationIdsInput: CustomersByCorrelationIdsInput!){
    customersByCorrelationIds(customersByCorrelationIdsInput: $customersByCorrelationIdsInput){
			correlationId
      firstName
      lastName
      email
      phoneNumber
      address{
        addressLine1
				addressLine2
        city
        state
        zipCode
      }
    }
  }
`;

export const GET_RECEIPT = `query receiptByCustomerOrderCorrelationIdForStores($getReceiptPreSignedUrlInput: GetReceiptPreSignedUrlInput!) {
  receiptByCustomerOrderCorrelationIdForStores(getReceiptPreSignedUrlInput: $getReceiptPreSignedUrlInput) {
    customerOrderCorrelationId
    restaurantCopy
    customerCopy
    kitchenCopy
    signatureImage
  }
}
`;

export const GET_CLIENT_DOWNLOAD_BUILDS = `query clientDownloadBuilds($platform: ClientPlatformEnum, $channel: ClientBuildChannelEnum) {
  clientDownloadBuilds(platform: $platform, channel: $channel) {
    correlationId
    platform
    channel
    version
    fileName
    objectKey
    sizeBytes
    checksumSha256
    uploadedAt
    isLatest
  }
}
`;

export const GET_CLIENT_DOWNLOAD_URL_BY_BUILD_ID = `query clientDownloadUrl($buildId: UUID!) {
  clientDownloadUrl(buildId: $buildId)
}
`;

export const GET_GRAPH_DATA_FOR_OWNER = `query loggedInUserSalesHistory($requestedHours: Int!){
  loggedInUserSalesHistory(requestedHours: $requestedHours){
     bucket
     storeUserCorrelationId
     orderNumber
     storeUserTotalPriceCents
     averageOrderTotalPriceCents
   }
 }
`;

export const VALIDATE_PROMOTION_CODE = `query validatePromotionCode($input: ValidatePromotionCodeInput!) {
  validatePromotionCode(input: $input) {
    valid
    reasonCode
    message
    promotionCorrelationId
    promotionCodeCorrelationId
    promotionName
    promotionType
    promotionCode
    normalizedCode
    discountValue
    subtotalCents
    discountAmountCents
    validationVersion
  }
}`;

export const GET_TAGS = `query tags($storeCorrelationId: UUID!) {
  tags(storeCorrelationId: $storeCorrelationId) {
    correlationId
    name
    category
  }
}`;

export const GET_STORE_PRINTERS = `query storePrinters($storeCorrelationId: UUID!) {
  storePrinters(storeCorrelationId: $storeCorrelationId) {
    correlationId
    assignedName
    model
    ipAddress
    port
    protocol
    isReceiptPrinter
    purpose
    enabled
  }
}`;

export const GET_CHANNELS = `query channels($storeCorrelationId: UUID!) {
  channels(storeCorrelationId: $storeCorrelationId) {
    correlationId
    name
    isActive
  }
}`;

export const GET_CHANNEL_ITEM_PRICES_BY_STORE = `query channelItemPricesByStore($storeCorrelationId: UUID!) {
  channelItemPricesByStore(storeCorrelationId: $storeCorrelationId) {
    correlationId
    storeCorrelationId
    channelCorrelationId
    itemCorrelationId
    priceCents
    isActive
  }
}`;

export const GET_CHANNEL_PRICE_ITEMS_BY_STORE = `query channelPriceItemsByStore($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter) {
  categoriesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter) {
    correlationId
    name
    items {
      correlationId
      englishName
      nonEnglishName
      priceCents
      active
    }
  }
}`;

export const GET_MODIFIER_ITEMS_BY_IDS = `query modifierItemsByCorrelationIds($modifierItemCorrelationIds: [UUID!]!) {
  modifierItemsByCorrelationIds(modifierItemCorrelationIds: $modifierItemCorrelationIds) {
    correlationId
    name
    nonEnglishName
    taxRate
    modifierItemOptions {
      correlationId
      name
      nonEnglishName
      priceCents
      renderSequence
      translations {
        locale
        name
        description
      }
    }
  }
}`;

export const GET_MODIFIER_CATEGORIES_BY_IDS = `query modifierCategoriesByCorrelationIds($modifierCategoryCorrelationIds: [UUID!]!) {
  modifierCategoriesByCorrelationIds(modifierCategoryCorrelationIds: $modifierCategoryCorrelationIds) {
    correlationId
    name
    nonEnglishName
    modifierItems {
      correlationId
      name
      nonEnglishName
      taxRate
      modifierItemOptions {
        correlationId
        name
        nonEnglishName
        priceCents
        renderSequence
      }
    }
  }
}`;

export const GET_MODIFIER_ITEM_OPTIONS_BY_IDS = `query modifierItemOptionsByCorrelationIds($modifierItemOptionsCorrelationIds: [UUID!]!) {
  modifierItemOptionsByCorrelationIds(modifierItemOptionsCorrelationIds: $modifierItemOptionsCorrelationIds) {
    correlationId
    name
    nonEnglishName
    priceCents
    renderSequence
  }
}`;

export const GET_MODIFIER_ITEM_OPTIONS_BY_ITEM_ID = `query modifierItemOptionsByItemCorrelationId($modifierItemCorrelationId: UUID!) {
  modifierItemOptionsByItemCorrelationId(modifierItemCorrelationId: $modifierItemCorrelationId) {
    correlationId
    name
    nonEnglishName
    priceCents
    renderSequence
  }
}`;

export const GET_MODIFIER_ITEMS_BY_CATEGORY_ID = `query modifierItemsByCategoryCorrelationId($modifierCategoryCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter) {
  modifierItemsByCategoryCorrelationId(modifierCategoryCorrelationId: $modifierCategoryCorrelationId, activeFilter: $activeFilter) {
    correlationId
    name
    nonEnglishName
    taxRate
    active
    modifierItemOptions {
      correlationId
      name
      nonEnglishName
      priceCents
      renderSequence
      translations {
        locale
        name
        description
      }
    }
  }
}`;

export const GET_MODIFIER_CATEGORIES_BY_STORE_ID = `query modifierCategoriesByStoreCorrelationId($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter) {
  modifierCategoriesByStoreCorrelationId(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter) {
    correlationId
    name
    nonEnglishName
    active
    translations {
      locale
      name
      description
    }
    modifierItems {
      correlationId
      name
      nonEnglishName
      taxRate
      active
      modifierItemOptions {
        correlationId
        name
        nonEnglishName
        priceCents
        renderSequence
      }
    }
  }
}`;

export const GET_EVENTS_BY_STORE_ID = `query storeEvents($storeCorrelationId: UUID!, $activeFilter: CategoryItemsActiveFilter) {
  storeEvents(storeCorrelationId: $storeCorrelationId, activeFilter: $activeFilter) {
    correlationId
    storeCorrelationId
    eventName
    eventDescription
    startDate
    endDate
    startTimeInSeconds
    endTimeInSeconds
    active
    eventItems {
      correlationId
      itemCorrelationId
      discountType
      discountPercent
      discountFixedPriceCents
      finalPriceCents
    }
    recurrences {
      correlationId
      recurrenceRule
    }
  }
}`;

// ——— Reporting API (ReportQueryInput: storeCorrelationId!, from?, to?, timezone?) ———

export const REPORTS_OVERVIEW = `
  query ReportsOverview($input: ReportQueryInput!) {
    reportsOverview(input: $input) {
      totalSalesCents
      netSalesCents
      ordersCount
      avgOrderValueCents
      totalTipsCents
      totalLaborHours
    }
  }
`;

export const REPORTS_SALES_SUMMARY = `
  query ReportsSalesSummary($input: ReportQueryInput!) {
    reportsSalesSummary(input: $input) {
      rows {
        date
        grossSalesCents
        discountsCents
        netSalesCents
        taxCents
        tipsCents
        ordersCount
        avgTicketCents
      }
      totalGrossCents
      totalNetCents
      totalOrders
    }
  }
`;

export const REPORTS_SALES_SUMMARY_PREVIOUS = `
  query ReportsSalesSummaryPrevious($input: ReportQueryInput!) {
    reportsSalesSummaryPrev: reportsSalesSummary(input: $input) {
      rows {
        date
        grossSalesCents
        discountsCents
        netSalesCents
        taxCents
        tipsCents
        ordersCount
        avgTicketCents
      }
      totalGrossCents
      totalNetCents
      totalOrders
    }
  }
`;

export const REPORTS_ITEM_SALES = `
  query ReportsItemSales($input: ReportQueryInput!) {
    reportsItemSales(input: $input) {
      rows {
        itemName
        quantitySold
        grossRevenueCents
        percentOfSales
      }
    }
  }
`;

export const REPORTS_COMBO_SELECTION_SALES = `
  query ReportsComboSelectionSales($input: ReportQueryInput!) {
    reportsComboSelectionSales(input: $input) {
      rows {
        itemName
        quantitySold
        grossRevenueCents
        percentOfSales
      }
    }
  }
`;

export const REPORTS_PAYMENT_SUMMARY = `
  query ReportsPaymentSummary($input: ReportQueryInput!) {
    reportsPaymentSummary(input: $input) {
      rows {
        paymentMethod
        count
        totalAmountCents
        percentOfTotal
      }
    }
  }
`;

export const REPORTS_EMPLOYEE_HOURS = `
  query ReportsEmployeeHours($input: ReportQueryInput!) {
    reportsEmployeeHours(input: $input) {
      rows {
        employeeName
        totalHours
        daysWorked
      }
    }
  }
`;

export const REPORTS_TAX_SUMMARY = `
  query ReportsTaxSummary($input: ReportQueryInput!) {
    reportsTaxSummary(input: $input) {
      rows {
        taxRate
        taxableSalesCents
        taxCollectedCents
      }
    }
  }
`;

// Analytics breakdowns (order_fact / order_item_fact)

export const REPORTS_SALES_BY_ORDER_TYPE = `
  query ReportsSalesByOrderType($input: ReportQueryInput!) {
    reportsSalesByOrderType(input: $input) {
      rows {
        orderType
        grossSalesCents
        discountsCents
        netSalesCents
        ordersCount
        avgTicketCents
        percentOfSales
      }
      totalGrossCents
      totalNetCents
      totalOrders
    }
  }
`;

export const REPORTS_SALES_BY_CHANNEL = `
  query ReportsSalesByChannel($input: ReportQueryInput!) {
    reportsSalesByChannel(input: $input) {
      rows {
        channel
        grossSalesCents
        discountsCents
        netSalesCents
        ordersCount
        avgTicketCents
        percentOfSales
      }
      totalGrossCents
      totalNetCents
      totalOrders
    }
  }
`;

export const REPORTS_SALES_BY_EMPLOYEE = `
  query ReportsSalesByEmployee($input: ReportQueryInput!) {
    reportsSalesByEmployee(input: $input) {
      rows {
        employeeName
        grossSalesCents
        discountsCents
        netSalesCents
        ordersCount
        avgTicketCents
        percentOfSales
      }
      totalGrossCents
      totalNetCents
      totalOrders
    }
  }
`;

export const REPORTS_TIPS_BY_EMPLOYEE = `
  query ReportsTipsByEmployee($input: ReportQueryInput!) {
    reportsTipsByEmployee(input: $input) {
      rows {
        employeeName
        totalTipsCents
        ordersCount
        percentOfTotal
      }
      totalTipsCents
    }
  }
`;

export const REPORTS_SALES_BY_CATEGORY = `
  query ReportsSalesByCategory($input: ReportQueryInput!) {
    reportsSalesByCategory(input: $input) {
      rows {
        categoryName
        quantitySold
        grossRevenueCents
        percentOfSales
      }
    }
  }
`;

export const REPORTS_EMPLOYEE_HOURS_BY_JOB_ROLE = `
  query ReportsEmployeeHoursByJobRole($input: ReportQueryInput!) {
    reportsEmployeeHoursByJobRole(input: $input) {
      rows {
        jobRoleName
        employeeName
        totalHours
        daysWorked
      }
    }
  }
`;

export const REPORTS_TIP_ALLOCATION = `
  query ReportsTipAllocation($input: ReportQueryInput!) {
    reportsTipAllocation(input: $input) {
      rows {
        employeeName
        employeeCorrelationId
        jobRoleId
        jobRoleName
        allocatedTipCents
      }
      totalAllocatedCents
    }
  }
`;

export const PAYROLL_PREVIEW = `
  query PayrollPreview($input: ReportQueryInput!) {
    payrollPreview(input: $input) {
      rows {
        employeeId
        employeeName
        payType
        hourlyRateCents
        salaryCents
        salaryPeriod
        hoursWorked
        basePayCents
        tipsEarnedCents
        tipsAllocatedNetCents
        tipsTakeHomeCents
        grossPayCents
        hoursBreakdown {
          storeJobRoleId
          jobRoleName
          hours
          rateCents
          basePayCents
        }
        warnings
      }
      summary {
        totalBasePayCents
        totalTipsTakeHomeCents
        totalGrossCents
      }
    }
  }
`;

export const PAYROLL_RUNS = `
  query PayrollRuns($storeCorrelationId: UUID!, $limit: Int) {
    payrollRuns(storeCorrelationId: $storeCorrelationId, limit: $limit) {
      id
      periodFrom
      periodTo
      status
      createdAt
      storeTimezone
      currency
      employeeCount
      totalMinutesWorked
      totalBasePayCents
      totalTipsTakeHomeCents
      totalGrossPayCents
      calculationVersion
    }
  }
`;

export const PAYROLL_RUN = `
  query PayrollRun($id: Long!, $storeCorrelationId: UUID!) {
    payrollRun(id: $id, storeCorrelationId: $storeCorrelationId) {
      id
      periodFrom
      periodTo
      status
      createdAt
      finalizedAt
      voidedAt
      notes
      createdByUserId
      createdByEmail
      storeTimezone
      currency
      employeeCount
      totalMinutesWorked
      totalBasePayCents
      totalTipsTakeHomeCents
      totalGrossPayCents
      calculationVersion
      employees {
        id
        employeeCorrelationId
        employeeName
        payType
        hourlyRateCents
        salaryCents
        salaryPeriod
        hoursWorked
        basePayCents
        tipsEarnedCents
        tipsAllocatedNetCents
        tipsTakeHomeCents
        grossPayCents
        hoursBreakdown {
          storeJobRoleId
          jobRoleName
          minutesWorked
          rateCents
          basePayCents
        }
        warnings
        sourceRefsJson
      }
    }
  }
`;

export const CREATE_PAYROLL_RUN_DRAFT = `
  mutation CreatePayrollRunDraft($input: ReportQueryInput!) {
    createPayrollRunDraft(input: $input) {
      id
      periodFrom
      periodTo
      status
      calculationVersion
      employeeCount
      totalGrossPayCents
    }
  }
`;

export const DELETE_PAYROLL_RUN = `
  mutation DeletePayrollRun($id: Long!, $storeCorrelationId: UUID!) {
    deletePayrollRun(id: $id, storeCorrelationId: $storeCorrelationId)
  }
`;

export const FINALIZE_PAYROLL_RUN = `
  mutation FinalizePayrollRun($id: Long!, $storeCorrelationId: UUID!) {
    finalizePayrollRun(id: $id, storeCorrelationId: $storeCorrelationId) {
      id
      status
      finalizedAt
    }
  }
`;

export const VOID_PAYROLL_RUN = `
  mutation VoidPayrollRun($id: Long!, $storeCorrelationId: UUID!) {
    voidPayrollRun(id: $id, storeCorrelationId: $storeCorrelationId) {
      id
      status
      voidedAt
    }
  }
`;

// ——— Payroll & Tips (job roles, staff roles, compensation, tip pools) ———

export const STORE_JOB_ROLES = `
  query StoreJobRoles($storeCorrelationId: UUID!, $activeOnly: Boolean) {
    storeJobRoles(storeCorrelationId: $storeCorrelationId, activeOnly: $activeOnly) {
      id
      storeCorrelationId
      name
      sortOrder
    }
  }
`;

export const STORE_STAFF_JOB_ROLES = `
  query StoreStaffJobRoles($storeStaffId: Long!) {
    storeStaffJobRoles(storeStaffId: $storeStaffId) {
      id
      storeStaffId
      storeJobRoleId
      isPrimary
      jobRoleName
    }
  }
`;

export const STORE_STAFF_JOB_ROLES_BY_STORE = `
  query StoreStaffJobRolesByStore($storeCorrelationId: UUID!) {
    storeStaffJobRolesByStore(storeCorrelationId: $storeCorrelationId) {
      id
      storeStaffId
      storeJobRoleId
      isPrimary
      jobRoleName
    }
  }
`;

export const STAFF_JOB_COMPENSATIONS = `
  query StaffJobCompensations($storeStaffId: Long!) {
    staffJobCompensations(storeStaffId: $storeStaffId) {
      id
      storeStaffId
      storeJobRoleId
      payType
      hourlyRateCents
      salaryCents
      overtimeMultiplier
      tipEligible
      tipWeightOverride
    }
  }
`;

export const STAFF_JOB_COMPENSATIONS_BY_STORE = `
  query StaffJobCompensationsByStore($storeCorrelationId: UUID!) {
    staffJobCompensationsByStore(storeCorrelationId: $storeCorrelationId) {
      id
      storeStaffId
      storeJobRoleId
      payType
      hourlyRateCents
      salaryCents
      overtimeMultiplier
      tipEligible
      tipWeightOverride
    }
  }
`;

export const TIP_POOLS = `
  query TipPools($storeCorrelationId: UUID!, $activeOnly: Boolean) {
    tipPools(storeCorrelationId: $storeCorrelationId, activeOnly: $activeOnly) {
      id
      storeCorrelationId
      name
      poolType
      isActive
    }
  }
`;

export const TIP_POOL_RULES = `
  query TipPoolRules($tipPoolId: Long!) {
    tipPoolRules(tipPoolId: $tipPoolId) {
      id
      tipPoolId
      storeJobRoleId
      jobRoleName
      percentOfSales
      percentOfTips
      weight
    }
  }
`;

export const ACTIVE_TIP_POOL_FOR_DATE = `
  query ActiveTipPoolForDate($storeCorrelationId: UUID!, $businessDate: Date!) {
    activeTipPoolForDate(storeCorrelationId: $storeCorrelationId, businessDate: $businessDate) {
      id
      name
      poolType
      isActive
    }
  }
`;

export const CREATE_STORE_JOB_ROLE = `
  mutation CreateStoreJobRole($storeCorrelationId: UUID!, $input: StoreJobRoleInput!) {
    createStoreJobRole(storeCorrelationId: $storeCorrelationId, input: $input) {
      id
      name
      sortOrder
    }
  }
`;

export const UPDATE_STORE_JOB_ROLE = `
  mutation UpdateStoreJobRole($id: Long!, $input: StoreJobRoleInput!) {
    updateStoreJobRole(id: $id, input: $input) {
      id
      name
      sortOrder
    }
  }
`;

export const DELETE_STORE_JOB_ROLE = `
  mutation DeleteStoreJobRole($id: Long!) {
    deleteStoreJobRole(id: $id)
  }
`;

export const ASSIGN_STORE_STAFF_JOB_ROLE = `
  mutation AssignStoreStaffJobRole($storeStaffId: Long!, $storeJobRoleId: Long!, $isPrimary: Boolean) {
    assignStoreStaffJobRole(storeStaffId: $storeStaffId, storeJobRoleId: $storeJobRoleId, isPrimary: $isPrimary) {
      id
      storeJobRoleId
      isPrimary
    }
  }
`;

export const REMOVE_STORE_STAFF_JOB_ROLE = `
  mutation RemoveStoreStaffJobRole($storeStaffId: Long!, $storeJobRoleId: Long!) {
    removeStoreStaffJobRole(storeStaffId: $storeStaffId, storeJobRoleId: $storeJobRoleId)
  }
`;

export const SET_STORE_STAFF_JOB_ROLE_PRIMARY = `
  mutation SetStoreStaffJobRolePrimary($storeStaffId: Long!, $storeJobRoleId: Long!) {
    setStoreStaffJobRolePrimary(storeStaffId: $storeStaffId, storeJobRoleId: $storeJobRoleId) {
      id
      isPrimary
    }
  }
`;

export const CREATE_OR_UPDATE_STAFF_JOB_COMPENSATION = `
  mutation CreateOrUpdateStaffJobCompensation($storeStaffId: Long!, $storeJobRoleId: Long!, $input: StaffJobCompensationInput!) {
    createOrUpdateStaffJobCompensation(storeStaffId: $storeStaffId, storeJobRoleId: $storeJobRoleId, input: $input) {
      id
      payType
      hourlyRateCents
      salaryCents
      overtimeMultiplier
      tipEligible
      tipWeightOverride
    }
  }
`;

export const DELETE_STAFF_JOB_COMPENSATION = `
  mutation DeleteStaffJobCompensation($id: Long!) {
    deleteStaffJobCompensation(id: $id)
  }
`;

export const CREATE_TIP_POOL = `
  mutation CreateTipPool($storeCorrelationId: UUID!, $input: TipPoolInput!) {
    createTipPool(storeCorrelationId: $storeCorrelationId, input: $input) {
      id
      name
      poolType
      isActive
    }
  }
`;

export const UPDATE_TIP_POOL = `
  mutation UpdateTipPool($id: Long!, $input: TipPoolInput!) {
    updateTipPool(id: $id, input: $input) {
      id
      name
      poolType
      isActive
    }
  }
`;

export const DELETE_TIP_POOL = `
  mutation DeleteTipPool($id: Long!) {
    deleteTipPool(id: $id)
  }
`;

export const CREATE_OR_UPDATE_TIP_POOL_RULE = `
  mutation CreateOrUpdateTipPoolRule($tipPoolId: Long!, $storeJobRoleId: Long!, $input: TipPoolRuleInput!) {
    createOrUpdateTipPoolRule(tipPoolId: $tipPoolId, storeJobRoleId: $storeJobRoleId, input: $input) {
      id
      percentOfSales
      percentOfTips
      weight
    }
  }
`;

export const DELETE_TIP_POOL_RULE = `
  mutation DeleteTipPoolRule($id: Long!) {
    deleteTipPoolRule(id: $id)
  }
`;

export const RUN_TIP_ALLOCATION = `
  mutation RunTipAllocation($storeCorrelationId: UUID!, $businessDate: Date!) {
    runTipAllocation(storeCorrelationId: $storeCorrelationId, businessDate: $businessDate) {
      success
      message
      allocationsCount
    }
  }
`;

// ——— Work sessions (clock in/out, timecards) ———

export const WORK_SESSION_SUMMARY = `
  query WorkSessionSummary($input: WorkSessionSummaryInput!) {
    workSessionSummary(input: $input) {
      userCorrelationId
      storeCorrelationId
      totalSecondsWorked
      currentlyClockedIn
      activeSessionClockInAt
      activeWorkSessionId
    }
  }
`;

export const GET_WORK_SESSIONS = `
  query GetWorkSessions($input: WorkSessionQueryInput!, $first: Int, $after: String, $last: Int, $before: String) {
    getWorkSessions(input: $input, first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfWorkSessions
      }
      edges {
        cursor
        node {
          id
          clockInAt
          clockOutAt
          notes
          storeCorrelationId
          userCorrelationId
          workDate
          createdBy
          updatedBy
        }
      }
    }
  }
`;

// ——— Cash drawer (cashTransactionsByStore, cashTransactionCreate) ———

export const CASH_TRANSACTIONS_BY_STORE = `
  query cashTransactionsByStore(
    $storeCorrelationId: UUID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $startTimeInEpochMilli: Long
    $endTimeInEpochMilli: Long
  ) {
    cashTransactionsByStore(
      storeCorrelationId: $storeCorrelationId
      first: $first
      after: $after
      last: $last
      before: $before
      startTimeInEpochMilli: $startTimeInEpochMilli
      endTimeInEpochMilli: $endTimeInEpochMilli
    ) {
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfTransactions
      }
      edges {
        cursor
        node {
          correlationId
          storeCorrelationId
          transactionType
          amountCents
          balanceAfter
          createdAt
          note
          relatedPaymentId
          createdByUserCorrelationId
        }
      }
    }
  }
`;

// ——— Finance Payments (order payment records) ———

export const PAYMENTS_BY_STORE_AND_PAYMENT_TYPE = `
  query paymentsByStoreCorrelationIdAndPaymentType(
    $storeCorrelationId: UUID!
    $startTimeInEpochMilli: Long!
    $endTimeInEpochMilli: Long!
    $paymentType: PaymentTypeEnum!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    paymentsByStoreCorrelationIdAndPaymentType(
      storeCorrelationId: $storeCorrelationId
      startTimeInEpochMilli: $startTimeInEpochMilli
      endTimeInEpochMilli: $endTimeInEpochMilli
      paymentType: $paymentType
      first: $first
      after: $after
      last: $last
      before: $before
    ) {
      paymentPageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
        totalNumberOfPages
        totalNumberOfPayments
      }
      edges {
        cursor
        node {
          correlationId
          customerOrderCorrelationId
          storeCorrelationId
          paymentDate
          createdAt
          paymentAmountCents
          changeCents
          paymentType
          paymentStatus
          paymentMethodType
          paymentMethodBrand
          last4Digits
          cardType
          stripePaymentIntentId
          nmiTransactionId
          finixTransferId
          amountAuthorizedCents
          amountCapturedCents
          settledAt
          paymentMode
        }
      }
    }
  }
`;

export const REFUND_CUSTOMER_ORDER_PAYMENT = `
  mutation refundCustomerOrderPayment($refundCustomerOrderPaymentInput: RefundCustomerOrderPaymentInput!) {
    refundCustomerOrderPayment(refundCustomerOrderPaymentInput: $refundCustomerOrderPaymentInput) {
      correlationId
      paid
      payment {
        correlationId
        paymentStatus
        finixTransferId
      }
    }
  }
`;


export const ENTERPRISE_STORE_WEEKDAY_CAPACITIES = `
  query EnterpriseStoreWeekdayCapacities($storeCorrelationId: UUID!) {
    enterpriseStoreWeekdayCapacities(storeCorrelationId: $storeCorrelationId) {
      dayOfWeek
      capacity
      active
    }
  }
`;
